import { createElement, type ReactNode } from 'react'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import SaveIcon from '@mui/icons-material/Save'
import type { BaseModalFooterAction } from '../base'
import { kiotButtonCancelSx, kiotButtonPrimarySx } from './kiotButtonStyles'

export type BuildKiotModalFooterActionsInput = {
  cancelLabel: ReactNode
  saveLabel: ReactNode
  onCancel: () => void
  onSave: () => void
  cancelDisabled?: boolean
  saveDisabled?: boolean
  cancelStartIcon?: ReactNode
  saveStartIcon?: ReactNode
}

export function buildKiotModalFooterActions({
  cancelLabel,
  saveLabel,
  onCancel,
  onSave,
  cancelDisabled,
  saveDisabled,
  cancelStartIcon = createElement(CloseOutlinedIcon),
  saveStartIcon = createElement(SaveIcon),
}: BuildKiotModalFooterActionsInput): BaseModalFooterAction[] {
  return [
    {
      id: 'cancel',
      label: cancelLabel,
      onClick: onCancel,
      variant: 'outlined',
      color: 'inherit',
      disabled: cancelDisabled,
      startIcon: cancelStartIcon,
      sx: kiotButtonCancelSx,
    },
    {
      id: 'save',
      label: saveLabel,
      onClick: onSave,
      variant: 'contained',
      color: 'primary',
      disabled: saveDisabled,
      startIcon: saveStartIcon,
      sx: kiotButtonPrimarySx,
    },
  ]
}

export type BuildKiotModalCloseActionInput = {
  label: ReactNode
  onClose: () => void
  startIcon?: ReactNode
}

export function buildKiotModalCloseAction({
  label,
  onClose,
  startIcon = createElement(CloseOutlinedIcon),
}: BuildKiotModalCloseActionInput): BaseModalFooterAction[] {
  return [
    {
      id: 'close',
      label,
      onClick: onClose,
      variant: 'outlined',
      color: 'inherit',
      startIcon,
      sx: kiotButtonCancelSx,
    },
  ]
}
